var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlurioPositivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 54,
    viewBox: "0 0 160 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-plurio-positivo",
    transform: "translate(-888 -202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_26",
    "data-name": "Ret\\xE2ngulo 26",
    width: 160,
    height: 54,
    transform: "translate(888 202)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(11832.164 18832.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M1083.348-472.575a1.906,1.906,0,0,0-1.348,1.913,2.364,2.364,0,0,0,.161.9,2.431,2.431,0,0,0,3.94.3,1.515,1.515,0,0,0,.334-1.21,1.648,1.648,0,0,0-.242-1.106A2.745,2.745,0,0,0,1083.348-472.575Z",
    transform: "translate(-11911.662 -18148.299)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M718.941-471.77a1.857,1.857,0,0,0-.576.542c-.2.3-.207.956-.242,11.879-.023,11.107-.023,11.58.184,12.052a1.575,1.575,0,0,0,1.636.876,1.575,1.575,0,0,0,1.636-.876c.207-.472.207-.945.184-12.052-.035-10.923-.046-11.58-.242-11.879a1.742,1.742,0,0,0-1.579-.772A1.8,1.8,0,0,0,718.941-471.77Z",
    transform: "translate(-11589.701 -18148.92)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M265.474-429.741a3.2,3.2,0,0,0-1.878,4.528,3.209,3.209,0,0,0,5.657.035,2.381,2.381,0,0,0,.346-1.5,2.345,2.345,0,0,0-.346-1.486,3.124,3.124,0,0,0-1.763-1.509A2.908,2.908,0,0,0,265.474-429.741Z",
    transform: "translate(-11187.23 -18186.178)",
    fill: "#7a12f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M341.406-413.792a7.164,7.164,0,0,0-.9.288l-.507.2.023,10.612.035,10.623.634.23a6.6,6.6,0,0,0,2.535.219,8.891,8.891,0,0,0,3.042-.311,10.72,10.72,0,0,0,7.339-5.957,10.51,10.51,0,0,0,.841-4.839,9.934,9.934,0,0,0-.311-3.157,10.157,10.157,0,0,0-3.41-5.392,11.969,11.969,0,0,0-5.473-2.454A14.512,14.512,0,0,0,341.406-413.792Z",
    transform: "translate(-11255.154 -18200.33)",
    fill: "#7a12f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M541.773-406.53a6.2,6.2,0,0,0-3.768,2.512l-.38.588-.058-1.083c-.081-1.6-.5-2.062-1.832-2.062a1.279,1.279,0,0,0-1.049.3c-.737.622-.691-.1-.691,11.914,0,10.013.012,11,.2,11.372a1.913,1.913,0,0,0,2.973.38l.346-.357.058-4.344.058-4.344.311.484a6.563,6.563,0,0,0,5.542,2.685,7.4,7.4,0,0,0,5.139-2.062,8.174,8.174,0,0,0,2.327-4.551,14.542,14.542,0,0,0-.115-5.427c-.991-3.745-3.641-6.014-7.155-6.118A8.875,8.875,0,0,0,541.773-406.53Zm1.728,2.846a4.025,4.025,0,0,1,2.339,1.221,6.733,6.733,0,0,1,1.636,4.931c0,3.975-1.786,6.164-5.024,6.164-2.731,0-4.367-1.728-4.77-5.012a9.952,9.952,0,0,1,.68-4.977A4.659,4.659,0,0,1,543.5-403.684Z",
    transform: "translate(-11426.798 -18206.738)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M979.477-406.183a8.467,8.467,0,0,0-3.019,1.106,5.6,5.6,0,0,0-1.532,1.717l-.219.4-.012-.968c0-1.648-.518-2.316-1.751-2.316a1.753,1.753,0,0,0-1.555.772c-.2.288-.207.818-.242,7.95-.023,4.9.012,7.8.092,8.077a1.845,1.845,0,0,0,.461.772,1.348,1.348,0,0,0,1.083.38c.979.069,1.521-.184,1.809-.83.2-.438.219-.853.219-5.208,0-5.335.035-5.588.864-6.821.8-1.164,1.786-1.648,4-1.936a8.641,8.641,0,0,0,1.74-.346,1.84,1.84,0,0,0,.461-2.247C981.539-406.241,980.836-406.391,979.477-406.183Z",
    transform: "translate(-11813.574 -18207.074)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M1159.109-406.5a8.231,8.231,0,0,0-5.219,3.422c-1.728,2.535-1.97,7.063-.542,10.07a7.9,7.9,0,0,0,5.243,4.275,13.713,13.713,0,0,0,4.9-.012,7.948,7.948,0,0,0,5.991-6.925,10.3,10.3,0,0,0-1.82-8.065,8.069,8.069,0,0,0-4.229-2.65A13.017,13.017,0,0,0,1159.109-406.5Zm2.869,2.823a4.408,4.408,0,0,1,3.1,2.109,7.029,7.029,0,0,1,.553,1.348,7.36,7.36,0,0,1,.277,2.765,6.626,6.626,0,0,1-.323,2.8,4.627,4.627,0,0,1-1.371,2.224,4.093,4.093,0,0,1-3.2,1.014,4.694,4.694,0,0,1-1.982-.254,4.764,4.764,0,0,1-2.7-3.364,14.243,14.243,0,0,1,0-4.943A4.675,4.675,0,0,1,1161.979-403.678Z",
    transform: "translate(-11973.966 -18206.756)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M793.7-405.756c-.7.588-.7.565-.7,6.256,0,5.173.069,6.441.426,7.558a5.479,5.479,0,0,0,2.731,3.353,7.977,7.977,0,0,0,6.418-.127,6.9,6.9,0,0,0,2.1-1.89l.253-.415.058,1.06c.058.979.092,1.083.4,1.417a1.627,1.627,0,0,0,1.567.472,1.544,1.544,0,0,0,1.256-.737c.219-.357.23-.645.23-8.238,0-8.688.035-8.319-.726-8.78a2.432,2.432,0,0,0-2.1,0c-.737.461-.749.518-.749,5.554,0,2.489-.058,4.885-.115,5.335a4.692,4.692,0,0,1-2.535,3.618,5.646,5.646,0,0,1-3.595.127,2.859,2.859,0,0,1-1.636-1.6c-.23-.507-.242-.737-.3-6.349a50.319,50.319,0,0,0-.2-6.049,1.542,1.542,0,0,0-1.578-.841C794.141-406.079,794.06-406.055,793.7-405.756Z",
    transform: "translate(-11655.96 -18207.26)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M1085.9-405.735c-.76.507-.737.207-.772,8.146-.023,3.964,0,7.535.035,7.939a1.56,1.56,0,0,0,.461,1.141c.357.4.426.426,1.233.461a1.81,1.81,0,0,0,1.221-.207c.737-.461.726-.219.691-8.906-.035-7.651-.046-7.869-.265-8.169a1.633,1.633,0,0,0-1.532-.668A1.629,1.629,0,0,0,1085.9-405.735Z",
    transform: "translate(-11914.422 -18207.314)",
    fill: "#10265a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M270-344.428c0,5.346.046,8.8.115,9.183a3.517,3.517,0,0,0,1.993,2.811,8.338,8.338,0,0,0,2.535.311c.184-.046.2-.645.2-10.462V-353H270Z",
    transform: "translate(-11193.22 -18254.209)",
    fill: "#7a12f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlurioPositivo);
export default __webpack_public_path__ + "static/media/logo-plurio-positivo.5e65533f00c8abd57336299bc0ee9cf1.svg";
export { ForwardRef as ReactComponent };